const RoleList = () => import('@/vuepage/auths-manage/RoleList');
const AdminList = () => import('@/vuepage/auths-manage/AdminList');
const RoleDialog = () => import('@/vuepage/auths-manage/components/RoleDialog');
const LogList = () => import('@/vuepage/auths-manage/LogList');
const LogDetail = () => import('@/vuepage/auths-manage/components/LogDetail');
const MenuList = () => import('@/vuepage/auths-manage/MenuList');

export default [{
		path: '/role-list',
		component: RoleList,
		meta: [{
				name: '权限管理'
			},
			{
				name: '角色管理',
				activeRoute: '/role-list'
			}
		]
	},
	{
		path: '/admin-list',
		component: AdminList,
		meta: [{
				name: '权限管理'
			},
			{
				name: '管理员列表',
				activeRoute: '/admin-list'
			}
		]
	},
	{
		path: '/role-dialog',
		component: RoleDialog,
		meta: [{
				name: '权限管理'
			},
			{
				name: '角色管理',
				activeRoute: '/admin-list'
			},
			{
				name: '新增/编辑角色',
				activeRoute: '/role-dialog'
			}
		]
	},
	{
		path: '/log-list',
		component: LogList,
		meta: [{
				name: '权限管理'
			},
			{
				name: '操作日志',
				activeRoute: '/log-list'
			}
		]
	},
	{
		path: '/log-detail',
		component: LogDetail,
		meta: [{
				name: '权限管理'
			},
			{
				name: '操作日志',
				activeRoute: '/log-list'
			},
			{
				name: '日志详情',
				activeRoute: '/log-detail'
			}
		]
	},
	{
		path: '/menu-list',
		component: MenuList,
		meta: [{
				name: '权限管理'
			},
			{
				name: '菜单管理',
				activeRoute: '/menu-list'
			}
		]
	},
];